import hvpAuthenticatedApi from "../api/hvpAuthenticatedApi";
import { IJob, IJobRequest, IJobResponse } from "../shared/types/";
import { IOption } from "../shared/types/option.types";
import { BaseServiceLegacy } from "./base.service.legacy";

export interface RecalculatePreviewItem {
  jobId: string;
  title: string;
  positionFactor: number;
  oldGuaranteedJobIncome: number;
  newGuaranteedJobIncome: number;
  oldJobFixedIncome: number;
  newJobFixedIncome: number;
  guaranteedDiff: number;
  fixedDiff: number;
}

export interface RecalculatePreviewResult {
  minimumWageHVP: number;
  year: number;
  items: RecalculatePreviewItem[];
}

export class JobService extends BaseServiceLegacy<IJobResponse, IJobRequest> {
  constructor() {
    super("/jobs");
  }

  async getPaymentTypes(): Promise<IOption[]> {
    const response = await hvpAuthenticatedApi.get("/jobs/payment-types");
    return response.data.data;
  }

  async recalculatePreview(year?: number): Promise<RecalculatePreviewResult> {
    const params = year ? { year } : {};
    const response = await hvpAuthenticatedApi.get("/jobs/recalculate-preview", { params });
    return response.data.data;
  }

  async applyRecalculation(year?: number): Promise<RecalculatePreviewResult> {
    const response = await hvpAuthenticatedApi.post("/jobs/apply-recalculation", { year });
    return response.data.data;
  }
}
